export default function Modal({
                   children,
                   onClose,
               }: {
    children: React.ReactNode;
    onClose: () => void;
}) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* BACKDROP */}
            <div
                className="absolute inset-0 bg-black/40 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* CONTENT */}
            <div className="relative bg-white max-w-2xl w-full mx-6 p-10 rounded-sm shadow-xl animate-fadeIn overflow-y-auto max-h-[80vh]">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl"
                >
                    ×
                </button>

                {children}
            </div>
        </div>
    );
}
